import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetCollection_pointsEnergy_intervals = z.any()
export type TagsGetCollection_pointsEnergy_intervals = z.infer<typeof tagsGetCollection_pointsEnergy_intervals>

export const querystringGetCollection_pointsEnergy_intervals = z.object({ "buildingId": z.string().optional(), "collectionPointId": z.string().optional(), "from": z.string().date().optional(), "to": z.string().date().optional(), "energyFlow": z.enum(["consumption","production"]).optional(), "granularity": z.enum(["quarterHour","day","month"]).optional() })
export type QuerystringGetCollection_pointsEnergy_intervals = z.infer<typeof querystringGetCollection_pointsEnergy_intervals>

export const responseGetCollection_pointsEnergy_intervals = z.object({ "payload": z.array(z.object({ "collectionPointId": z.string(), "energyFlow": z.enum(["consumption","production"]), "period": z.string(), "valueKwh": z.number() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetCollection_pointsEnergy_intervals = z.infer<typeof responseGetCollection_pointsEnergy_intervals>

interface IGetCollection_pointsEnergy_intervals extends BaseMethodType {
  tags: TagsGetCollection_pointsEnergy_intervals,
  querystring: QuerystringGetCollection_pointsEnergy_intervals,
  response: ResponseGetCollection_pointsEnergy_intervals
}
export const URL = '/collection-points/energy-intervals'
export const validation = {
  get: {
    tags: tagsGetCollection_pointsEnergy_intervals,
    querystring: querystringGetCollection_pointsEnergy_intervals,
    response: responseGetCollection_pointsEnergy_intervals
  }
}
export interface Collection_pointsEnergy_intervals extends BaseRouteType {
  get: IGetCollection_pointsEnergy_intervals
}